export default __webpack_public_path__ + "static/media/BE_Sciences_RGB_Horizontal_Color.27e0fe77.svg";